import React, { useEffect, useState, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { subscription, getCode } from "./api";
import { getQuery } from "@/service/http";
import "./email.less";
import backImg from "./images/back.svg";
import checkRedImg from "./images/check_red.svg";
import checkNormalImg from "./images/check_normal.svg";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const navigateBack = () => {
  // 如果是在小程序打开，调用小程序的返回上一页方法
  if (window.wx && window.wx.miniProgram) {
    window.wx.miniProgram.navigateBack();
  } else {
    window.history.back();
  }
}

export default function EmailCollect() {
  const { t } = useTranslation();
  const loading = useRef(null);
  const [email, setEmail] = useState("");
  const [checked, setChecked] = useState(true);
  const [showNotify, setShowNotify] = useState(false);
  const [status, setStatus] = useState("");
  const [errmsg, setErrmsg] = useState("");
  const { lang, hideBack, voucher_batch_id = '' } = getQuery();
  const showBack = hideBack == 'true' ? false : true

  useEffect(() => {
    // 进入页面后，如果是移动端，则隐藏导航栏，退出页面需要恢复
    const body = document.body
    body.classList.add("hide-navbar");
    return () => {
      body.classList.remove("hide-navbar");
    };
  }, []);


  const enable = useMemo(() => {
    return email.length > 0;
  }, [email]);

  function goBack() {
    if (!showBack) return
    navigateBack();
  }
  function onChange(ev) {
    let str = ev.target.value;
    setEmail(str);
    setErrmsg("");
    setStatus("");
  }
  async function submit() {
    if (loading.current) return;
    if (!enable) return;
    loading.current = true;
    // email格式错误
    if (!emailRegex.test(email)) {
      setStatus("error");
      setErrmsg(t("Collect.Invalid email format"));
      loading.current = false;
      return
    }
    try {
      setStatus("");
      // 领取券码
      await getCode({
        email: email,
        voucher_batch_id: voucher_batch_id,
      });
      // 订阅营销邮件
      if (checked) {
        subscription({
          newsletter_subscription: {
            email: email,
            locale: lang,
          },
        });
      }
      // 领取成功后弹出提示，禁止再次点击
      setShowNotify(true);
    } catch (error) {
      loading.current = false;
      console.error(error);
      setStatus("error");
      setErrmsg(error.data.full_messages[0]);
    }
  }
  return (
    <div className="email-collect-page">
      <div className="collect-page-header">
        <div className="page-header-left" onClick={goBack}>
          {showBack && <img src={backImg} width={24} height={24} />}
        </div>
        <div className="page-header-center">
          {t("Collect.Enter Email to Get Voucher")}
        </div>
        <div className="page-header-right"></div>
      </div>
      <div className="collect-page-header-pc">
        {t("Collect.Enter Email to Get Voucher")}
      </div>
      <div className="collect-page-body">
        <div className="collect-input-desc">{t("Collect.input desc")}</div>
        <input
          type="text"
          placeholder={t("Collect.Please enter your email")}
          value={email}
          onChange={onChange}
          data-status={status}
        />
        {status === "error" && (
          <div className="collect-input-error">
            {errmsg}
          </div>
        )}
        <div className="collect-checkbox">
          <div
            className="collect-checkbox-inner"
            onClick={() => setChecked(!checked)}
          >
            <img
              src={
                checked
                  ? checkRedImg
                  : checkNormalImg
              }
              width={16}
              height={16}
            />
            <span>{t("Collect.Subscribe to Marketing emails")}</span>
          </div>
        </div>
      </div>
      <div className="collect-page-float">
        <div className="float-button" data-enable={enable} onClick={submit}>
          <div className="float-button-inner">
            {t("Collect.Get Voucher Now")}
          </div>
        </div>
      </div>
      <Success show={showNotify} onClose={() => setShowNotify(false)}></Success>
    </div>
  );
}
function Success({show}) {
  const { t } = useTranslation();
  const { hideBack } = getQuery();
  const showBack = hideBack == 'true' ? false : true

  const [animate, setAnimate] = useState("");
  useEffect(() => {
    if (show) {
      setAnimate("fade-in");
    }
  }, [show]);

  function goBack() {
    if (!showBack) return
    navigateBack();
  }

  return (
    <div className={`email-collect-page fixed-page ${animate}`}>
      <div className="collect-page-header">
        <div className="page-header-left" onClick={goBack}>
          {showBack && <img src={backImg} width={24} height={24} />}
        </div>
        <div className="page-header-center">
          {t("Collect.Successfully claimed")}
        </div>
        <div className="page-header-right"></div>
      </div>
      <div className="collect-page-body">
        <div className='collect-notify'>
          <img
            className="collect-notify-icon"
            src={checkRedImg}
            width={48}
            height={48}
          />
          <div className="collect-notify-content" dangerouslySetInnerHTML={{
            __html: t("Collect.notice")
          }}></div>
        </div>

      </div>
    </div>
  );
}
